module.exports = __webpack_public_path__ + "static/media/disassociated_contact_tag_no_text.03a985d1.svg";